import { CommonTableRow } from './CommonTableRow';

export default CommonTableRow;
